import { withI18n } from 'react-i18next';
import DateRangeSeparated from './DateRangeSeparated';

export const pureComponent = DateRangeSeparated;
export default withI18n()(DateRangeSeparated);
